export class ChangePerformerUser {
	requestId: number;
	performerUserId: number;

	constructor(requestId: number, 	performerUserId: number) {
        this.requestId = requestId;
        this.performerUserId = performerUserId;
    }
}